import { parseDate } from "../utilities/parseHelper";
import { DateType } from "./types/index";
import urlFilter from "../filters/url.filter";

/**
 * Класс данных шаблонов платежа.
 */
export class TemplateData {
  /**
   * Внутренний ИД шаблона платежа. (не используется).
   */
  public Id: number = 0;

  /**
   * Заголовок шаблона платежа.
   */
  public Caption: string = "";

  /**
   * Наименование шаблона платежа.
   */
  public Name: string = "";

  /**
   * URL каритнки платежа.
   */
  public Picture: string = "";

  /**
   * URL большой картинки платежа.
   */
  public BigImage: string = "";

  /**
   * Сумма платежа.
   */
  public Sum: number = 0;

  /**
   * Код валюта шаблона платежа.
   */
  public CurrencyCharCode: string = "";

  /**
   * Активный шаблон.
   */
  public IsActive: boolean = false;

  /**
   * Режим периодичности:
   * 0 - нет.
   * 1 - Ежедневно.
   * 2 - Еженедельно.
   * 3 - Ежемесячно.
   */
  public Period: number = 0;

  /**
   * День периодичности для еженедельного и ежемесячного режима.
   */
  public DayNumber: number = 0;

  /**
   * Дата следующего исполнения.
   */
  public NextDate: DateType | number = null;

  /**
   * Конструктор с загрузкой данных c сервера.
   * @param  src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      this.Id = src.Id ?? 0;
      this.Caption = src.Caption ?? "";
      this.Name = src.Name ?? "";
      this.Picture = src.Picture ? urlFilter(src.Picture) : "";
      this.BigImage = src.BigImage ? urlFilter(src.BigImage) : "";
      this.Sum = src.Sum ?? 0;
      this.CurrencyCharCode = src.CurrencyCharCode ?? "";
      this.IsActive = src.IsActive ?? false;
      this.Period = src.Period ?? 0;
      this.DayNumber = src.DayNumber ?? 0;
      this.NextDate = parseDate(src.Nextdate ?? null);
    }
  }

  /**Копирование объекта */
  public copy(template: TemplateData) {
    this.Id = template.Id;
    this.Caption = template.Caption;
    this.Name = template.Name;
    this.Picture = template.Picture;
    this.BigImage = template.BigImage;
    this.Sum = template.Sum;
    this.CurrencyCharCode = template.CurrencyCharCode;
    this.IsActive = template.IsActive;
    this.Period = template.Period;
    this.DayNumber = template.DayNumber;
    this.NextDate = template.NextDate;
  }
}
